var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92556 0 0 4.836 0 10.8C0 15.804 3.47111 20.004 8.17667 21.228L11 24L13.8233 21.228C18.5289 20.004 22 15.804 22 10.8C22 4.836 17.0744 0 11 0ZM11 2.4C13.0289 2.4 14.6667 4.008 14.6667 6C14.6667 7.992 13.0289 9.6 11 9.6C8.97111 9.6 7.33333 7.992 7.33333 6C7.33333 4.008 8.97111 2.4 11 2.4ZM11 19.56C7.94444 19.56 5.24333 18.024 3.66667 15.696C3.70333 13.308 8.55556 12 11 12C13.4322 12 18.2967 13.308 18.3333 15.696C16.7567 18.024 14.0556 19.56 11 19.56Z",
    fill: "currentColor"
  })));
};
export default SvgProfile;